const columns = ['firstName', 'lastName', 'organization', 'email', 'actions']
export const [
  COLUMN_FIRST_NAME,
  COLUMN_LAST_NAME,
  COLUMN_ORGANIZATION,
  COLUMN_EMAIL,
  COLUMN_ACTIONS,
] = columns

export const gridColumns = [
  {
    key: COLUMN_FIRST_NAME,
    size: 0.5,
  },
  {
    key: COLUMN_LAST_NAME,
    size: 0.5,
  },
  {
    key: COLUMN_ORGANIZATION,
    size: 0.5,
  },
  {
    key: COLUMN_EMAIL,
    size: 0.75,
  },
  {
    key: COLUMN_ACTIONS,
    size: 1,
  },
]
